const baseModule = 'EVENTS';

export const SET_STORE = `${baseModule}/SET_STORE`;
export const SET_STORE_INTERVAL = `${baseModule}/SET_STORE_INTERVAL`;
export const SET_STORE_ITEMS = `${baseModule}/SET_STORE_ITEMS`;
export const UPDATE_STORE_ITEM = `${baseModule}/UPDATE_STORE_ITEM`;
export const CHANGE_ITEM_STORE = `${baseModule}/CHANGE_ITEM_STORE`;
